import { useGetOfficeMembersData } from '@/context/services/import_export_histories/ImportExportHistories.service';
import { useEffect, useRef, useState } from 'react';

const useInitialData = <T>(
  ids: string[],
  fetchFunction: (ids: string[]) => Promise<T[]>
) => {
  const [options, setOptions] = useState<T[]>([]);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!hasFetchedRef.current) {
      hasFetchedRef.current = true;
      if (ids.length === 0) {
        setOptions([]);
        return;
      }
      const fetchData = async () => {
        try {
          const data = await fetchFunction(ids);
          setOptions(data);
        } catch {
          setOptions([]);
        }
      };

      fetchData();
    }
  }, [ids, fetchFunction]);

  return { options };
};

export const useOfficeMembersInitialData = (memberIds: string[]) => {
  const { fetchOfficeMembers } = useGetOfficeMembersData();
  const { options } = useInitialData(memberIds, fetchOfficeMembers);

  return options;
};
